module.exports = __webpack_public_path__ + "static/media/box.060d9c23.png";